// Hero rotating banner — slide swap via data-active attribute.
// Runs after DOMContentLoaded so the section markup is present.
// One timer, re-armed after every change: a dot click restarts the clock, and
// hover, keyboard focus, the pause button or reduced motion hold the slide.
(function () {
  // Full-screen hero: CSS sizes it to 100svh minus where it starts (header,
  // utility bar, nav). Measured, not hard-coded: the header height differs per
  // breakpoint and changes when the nav or promo bar changes.
  function fitToScreen(banner) {
    const top = Math.round(banner.getBoundingClientRect().top + window.scrollY);
    banner.style.setProperty('--hero-top', top + 'px');
  }

  function initBanner(banner) {
    fitToScreen(banner);
    let fitQueued = false;
    const refit = () => {
      if (fitQueued) return;
      fitQueued = true;
      window.requestAnimationFrame(() => { fitQueued = false; fitToScreen(banner); });
    };
    window.addEventListener('resize', refit);
    window.addEventListener('load', refit);
    const slides = banner.querySelectorAll('.hero-banner__slide');
    const dots = banner.querySelectorAll('.hero-banner__dot');
    const counter = banner.querySelector('.hero-banner__counter-current');
    const pauseBtn = banner.querySelector('[data-hero-pause]');
    const autoplayMs = (parseInt(banner.dataset.autoplaySeconds, 10) || 0) * 1000;
    if (slides.length < 2) return;
    const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    let idx = 0;
    let timer = null;
    let paused = reduceMotion;
    let hovered = false;
    let focused = false;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, j) => {
        s.dataset.active = (j === idx) ? 'true' : 'false';
        // Hidden slides leave the tab order and the accessibility tree.
        if (j === idx) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach((d, j) => {
        if (j === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0');
    }

    function schedule() {
      if (timer) window.clearTimeout(timer);
      timer = null;
      if (autoplayMs > 0 && !paused && !hovered && !focused) {
        timer = window.setTimeout(() => { show(idx + 1); schedule(); }, autoplayMs);
      }
    }

    function syncPause() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    }

    dots.forEach((dot, j) => dot.addEventListener('click', () => { show(j); schedule(); }));
    if (pauseBtn) pauseBtn.addEventListener('click', () => { paused = !paused; syncPause(); schedule(); });
    banner.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    banner.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    // Only KEYBOARD focus holds the slide: a mouse click also focuses the dot or
    // Play button, and Play must not leave the slideshow stuck until focus moves.
    let pointerDown = false;
    banner.addEventListener('pointerdown', () => { pointerDown = true; });
    banner.addEventListener('pointerup', () => { window.setTimeout(() => { pointerDown = false; }, 0); });
    banner.addEventListener('focusin', () => {
      if (pointerDown) { pointerDown = false; return; }
      focused = true;
      schedule();
    });
    banner.addEventListener('focusout', (e) => {
      if (banner.contains(e.relatedTarget)) return;
      focused = false;
      schedule();
    });

    syncPause();
    schedule();
  }

  function init() {
    document.querySelectorAll('.hero-banner').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
